import React from 'react'
import Navbar from '../../component/Other/Navbar'
import Footer from '../../component/Page/Footer'
import Seen from "../../component/Page/Seen"

const Book = () => {
    return (
        <div className="overflow-hidden">
            <Navbar type={"dark"} />

            <section>
                <div className="container">
                    <div className="mb-5 text-center text-md-left">
                        <div className="d-flex align-items-center justify-content-center justify-content-md-start normal font__size--24 text__24-1024 text-capitalize color__brown mb-3">
                            <img src="./../images/Vector 2.png" alt="" />
                            <span className="mx-3">Book Now</span>
                            <img src="./../images/Vector 1.png" alt="" />
                        </div>
                        <h2 className="medium font__size--48 text__48-1024 text__48-md text__48-sm text__48-xx play">Make your dreams <br /> come true</h2>
                    </div>

                    <div className="row">
                        <div className="order-md-1 order-12 col-md-4 col-lg-3 mt-5 my-md-auto">
                            <img src="./../images/Avatar (1).png" className='images__profile-contact mb-3' alt="" />
                            <p className=' normal font__size--18 text__18-1024 mb-4'>Our manager Rhiel Madsen will call you back: </p>

                            <ul className="list__footer  normal font__size--18 text__18-1024">
                                <li>
                                    <div className="d-flex align-items-start">
                                        <img src="./../images/icn (2).png" className='img-content' alt="" />
                                        <span className='ml-2'>momentwedding@gmail.com</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="d-flex align-items-start">
                                        <img src="./../images/icn (3).png" className='img-content' alt="" />
                                        <span className='ml-2'>123-456-7890</span>
                                    </div>
                                </li>
                                <li>
                                    <div className="d-flex align-items-start">
                                        <img src="./../images/icn (1).png" className='img-content' alt="" />
                                        <span className='ml-2'>River RoadColorado SpringsCO, Colorado80906</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="order-1 order-md-12 col-md-7 offset-md-1 offset-lg-2 my-auto">

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <input type="text" className='form-control play font__size--14 text__14-1024 normal wrapper__field-input' placeholder='First Name' />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <input type="text" className='form-control play font__size--14 text__14-1024 normal wrapper__field-input' placeholder='Last Name' />
                                    </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <input type="text" className='form-control play font__size--14 text__14-1024 normal wrapper__field-input' placeholder='Email' />
                            </div>

                            <div className="form-group">
                                <input type="text" className='form-control play font__size--14 text__14-1024 normal wrapper__field-input' placeholder='Phone Number*' />
                            </div>

                            <div className="form-group">
                                <input type="text" className='form-control play font__size--14 text__14-1024 normal wrapper__field-input' placeholder='How can we help you?' />
                            </div>

                            <button className='medium font__size--16 btn btn__darkgreen color__white shadow rounded__50 mt-4'>Send Message</button>

                        </div>
                    </div>
                </div>
            </section>

            <Seen />

            <Footer />
        </div >
    )
}

export default Book